// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";

import { token } from "@atlaskit/tokens";

type ListOfLinksHeaderTextProps = {
    readonly isSideBar: boolean;
    readonly headerText: string;
};

export const ListOfLinksHeaderText = ({
    isSideBar,
    headerText
}: ListOfLinksHeaderTextProps) => {
    const headerTextStyle = css`
        padding-bottom: ${isSideBar ? token("space.200") : "0"};
        padding-top: ${isSideBar ? "15px" : "0"};
        color: #42526e;
        margin: 0 0 ${token("space.100")} 0;
        font-weight: 500;
        font-size: ${token("space.150")};
        line-height: 1.5;
        letter-spacing: 1px;
        text-transform: uppercase;
        width: 100%;
    `;
    return <h2 css={headerTextStyle}>{headerText.trim().toUpperCase()}</h2>;
};
